import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import uuidv4 from "uuid/v4";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";
import { useFormik } from "formik";
import * as yup from "yup";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";

import * as actions from "../../../store/actions";
import * as appsyncOperations from "../../../utils/appsyncOperations";
import { isUserRole } from "../../../utils/user";
import LoadingButton from "../../Buttons/Loading";

const CreateDivision = ({ isOpen, onClose }) => {
  const classes = useStyles();
  const enqueueSnackbar = useSnackbar().enqueueSnackbar;
  const dispatch = useDispatch();
  const serviceProviderId = useSelector(
    (state) => state.serviceProvider.serviceProvider.serviceProviderId
  );
  const [isLoading, setIsLoading] = useState(false);

  const form = useFormik({
    initialValues: {
      displayName: "",
    },
    onSubmit: (values) => formSubmit(values),
    validationSchema: yup.object({
      displayName: yup
        .string()
        .max(140, "Must be 140 characters or less.")
        .required("Required"),
    }),
  });

  const formSubmit = async () => {
    setIsLoading(true);
    try {
      const division = await appsyncOperations.createDivision({
        divisionId: uuidv4(),
        displayName: form.values.displayName,
        serviceProviderId,
      });
      setIsLoading(false);
      dispatch(actions.divisions.setDivision(division));
      enqueueSnackbar("Create successful!", { variant: "success" });
      onClose();
    } catch (e) {
      setIsLoading(false);
    }
  };

  const displayNameError = form.touched.displayName && form.errors.displayName;

  const isAdmin = isUserRole({ admin: true });

  if (!isAdmin)
    return (
      <>
        <Dialog open={isOpen} onClose={onClose} maxWidth={"md"} fullWidth>
          <DialogTitle>Create division</DialogTitle>
          <DialogContent>
            <DialogContentText>You are not the correct role.</DialogContentText>
          </DialogContent>
        </Dialog>
      </>
    );

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth={"sm"} fullWidth>
      <DialogTitle>Create Division</DialogTitle>
      <DialogContent>
        <TextField
          id={"displayName"}
          label="Display Name"
          onBlur={form.onBlur}
          value={form.displayName}
          onChange={form.handleChange}
          required={true}
          variant="filled"
          fullWidth
          error={displayNameError}
          helperText={displayNameError ? form.errors.displayName : null}
        />
        <div className={classes.actionsContainer}>
          <Button onClick={onClose} className={classes.button}>
            Cancel
          </Button>
          <LoadingButton
            variant="contained"
            color="primary"
            onClick={form.submitForm}
            className={classes.button}
            isLoading={isLoading}
          >
            Finish
          </LoadingButton>
        </div>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles((theme) => ({
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  actionsContainer: {
    marginTop: theme.spacing(2),
  },
}));

export default CreateDivision;
